import React from "react";
import {
  Box, Button, Link, Stack, Typography,
} from "@mui/material";
import { Trans } from "@lingui/macro";
import styled from "@emotion/styled";
import { useLocalization } from "gatsby-theme-i18n";
import Checkbox from "./Checkbox";
import Modal from "./Modal";
import { useCookiesHook } from "../hooks/useCookiesHook";

const COOKIES = () => [
  {
    key: "technical",
    disabled: true,
    label: <Trans>Necessary technical cookies</Trans>,
    description: (
      <Trans>
        These cookies enable core functionality and they are necessary for the
        website to work correctly. You may disable these by changing your
        browser settings, but this may affect the website functions.
      </Trans>
    ),
  },
  {
    key: "analytics",
    label: <Trans>Analytics cookies</Trans>,
    description: (
      <Trans>
        These cookies collect information in an anonymous form. If you consent
        their installation, Google Analytics cookies will be setted in your
        device for improving ALLFUNDS website by collecting and reporting
        information on how you use it.
      </Trans>
    ),
  },
];

function ModalCookies({ open, onClose }) {
  const { locale } = useLocalization();
  const { cookies, acceptSomeCookies } = useCookiesHook();
  const [values, setValues] = React.useState({});

  React.useEffect(() => {
    setValues(cookies || {analytics: false});
  }, []);

  return (
    <Modal open={open} onClose={onClose} backgroundColor="white" width={680}>
      <Typography sx={{ fontSize: 20, fontWeight: 700 }}>
        <Trans>Cookies Settings</Trans>
      </Typography>
      <Stack spacing={2} mt={2}>
        {COOKIES().map(({
          key, label, description, disabled = false,
        }) => (
          <Box>
            <Checkbox
              disabled={disabled}
              checked={disabled ? true : values[key]}
              onChange={() => !disabled
                && setValues({
                  ...values,
                  [key]: !values[key],
                })}
            >
              <Typography fontWeight={700}>{label}</Typography>
            </Checkbox>
            <Typography mt={1} sx={{ color: (theme) => theme.palette.primary.main }}>{description}</Typography>
          </Box>
        ))}
        <StyledTypography>
          <Trans>
            You can consult our
            {" "}
            <Link href={`/${locale}/legal-advice/cookies-policy`} target="_blank">
              <Trans>cookies policy.</Trans>
            </Link>
            {" "}
            at any time here or on the web
          </Trans>
          .
        </StyledTypography>
        <Stack spacing={2} direction="row" justifyContent="space-between">
          <Button
            variant="secondary-outline"
            mr={2}
            onClick={() => onClose()}
          >
            <Typography color="secondary" fontWeight="700 !important">
              <Trans>Cancel</Trans>
            </Typography>
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              acceptSomeCookies(values.personalization, values.analytics);
              onClose();
            }}
          >
            <Typography sx={{ fontWeight: "600 !important", fontSize: 16, color: "white" }}>
              <Trans>Accept cookies</Trans>
            </Typography>
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
}

const StyledTypography = styled(Typography)`
  > a {
    text-decoration: underline;
    color: ${({ theme }) => theme.palette.secondary.main};
    cursor: pointer;
    margin-left: 0.325rem; 
    margin-right: 0.325rem; 
  }
`;

export default ModalCookies;
